import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface BiomassBurningCellDisplayProps {
  value: any
}

export const BiomassBurningCellDisplay = ({ value }: BiomassBurningCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')

  const percentage = value?.result ?? value?.input?.percentage

  return (
    <Stack>
      <Typography>
        {value?.result?.hadBiomassBurning === false
          ? t('no')
          : value?.result?.hadBiomassBurning === true
          ? t('yes')
          : ''}
      </Typography>
    </Stack>
  )
}
